
define('lib/audio/available-countries-filter',['require','exports','module','lodash'],function (require, exports, module) {
    var _ = require('lodash');

    /**
    * Available Countries Filter
    * filter the listOfCounties by the available countries.
    * This is to prevent any list of countries (selected, prefered, etc)
    * to contain countries that are not available in the account
    *
    * @param {Array} listOfCountries - List of county codes to be filtered
    * @param {Array} availableCountries - List of countries that can exist in the result
    * @result {Array} - a filter list of countires
    *
    */
    function filter(listOfCountries, availableCountries) {
        return _.intersection(listOfCountries, availableCountries);
    }

    module.exports = filter;
});

